import { FC, memo, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Divider, IconButton, Link, ListItemIcon } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { deleteMessageRequest, markAsReadMessageRequest } from 'redux/reducers/user/reducer';
import DeleteIcon from '@mui/icons-material/Delete';
import { DeleteDialog } from 'ui/DeleteDialog';
import { PATHS } from 'routes/constants';
import { TUserMenuItemProps } from './types';

export const MessagesMenuItem: FC<TUserMenuItemProps> = ({
	message,
	selectedMessage,
	onSelectMessage,
}) => {
	const dispatch = useDispatch();
	// const [showAll, setShowAll] = useState(false);

	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const handleCloseDeleteDialog = () => setOpenDeleteDialog(false);

	const handleShowAll = () => {
		onSelectMessage(true);
		if (!message.isRead)
			setTimeout(() => dispatch(markAsReadMessageRequest({ messageId: message.id })), 1000);
	};

	const handleOpenDeleteDialog = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		setOpenDeleteDialog(true);
	};

	const handleDelete = () => {
		setOpenDeleteDialog(false);
		dispatch(deleteMessageRequest({ messageId: message.id }));
		onSelectMessage(false);
	};

	return (
		<MenuItem key={nanoid()}>
			{/* {message.attachment ? (
				<ListItemIcon>
					<AttachFileIcon />
				</ListItemIcon>
			) : (
				<div style={{ width: '36px' }} />
			)} */}

			<Box
				sx={{
					width: 'calc(100% - 0px)',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'start',
					alignItems: 'start',
					border: selectedMessage ? '1px solid #ddd' : 'none',
					backgroundColor: selectedMessage ? '#f5f5f5' : 'transparent',
					borderRadius: '12px',
					padding: selectedMessage ? '10px' : 0,
					margin: selectedMessage ? '12px 0' : 0,
					fontSize: selectedMessage ? '1rem!important' : '0.8rem!important',
				}}
				onClick={handleShowAll}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
						width: '100%',
					}}
				>
					<Typography
						textAlign="left"
						sx={{ fontWeight: message.isRead ? 300 : 900 }}
						color="text.secondary"
						variant="body2"
					>
						{new Date(message.date).toLocaleDateString()}{' '}
						{new Date(message.date).toLocaleTimeString()}
					</Typography>
					{message.isRead && selectedMessage && (
						<IconButton onClick={handleOpenDeleteDialog}>
							<DeleteIcon fontSize="small" color="primary" />
						</IconButton>
					)}
				</Box>
				<Typography
					textAlign="left"
					sx={{
						fontWeight: message.isRead ? 300 : 900,
						fontSize: selectedMessage ? '1rem!important' : '0.9rem!important',
						color: 'primary.main',
					}}
				>
					{message.messageTtype}
				</Typography>
				<Typography
					textAlign="left"
					sx={{
						fontWeight: message.isRead ? 300 : 900,
						width: '100%',
						whiteSpace: selectedMessage ? 'normal' : 'nowrap',
						overflow: selectedMessage ? 'visible' : 'hidden',
						textOverflow: 'ellipsis',
						fontSize: selectedMessage ? '1rem!important' : '0.8rem!important',
						// display: 'contents',
					}}
					// variant="body2"
					component="div"
				>
					{message.message}
					{selectedMessage && message.attachment === '/view/invoices' && (
						<p>
							<Link
								href={PATHS.INVOICES_PAGE}
								target="_blank"
								rel="noreferrer"
								sx={{ color: 'primary.main', textDecoration: 'none', fontWeight: 900 }}
							>
								Go to invoices
							</Link>
						</p>
					)}
					{/* {selectedMessage || <Divider variant="middle" sx={{ marginTop: '10px' }} />} */}
				</Typography>
			</Box>
			<DeleteDialog
				open={openDeleteDialog}
				setClose={handleCloseDeleteDialog}
				handleDelete={handleDelete}
				text="Are you sure you want to delete this message?"
			/>
		</MenuItem>
	);
};

export const MessagesMenuItemMemo = memo(MessagesMenuItem);
